import { z } from 'zod';

/**
 * Schema for ghost text data with locale.
 * Used to persist and restore dynamic placeholder text across sessions.
 */
export const GhostTextDataV2Schema: z.ZodObject<
	{
		/** Unique key identifying the current ghost text set */
		id: z.ZodString;
		/** Locale of the ghost text */
		locale: z.ZodString;
		/** The placeholder text to display */
		text: z.ZodString;
		/** Number of times this text has been shown (0-2, resets after 3) */
		occurrence: z.ZodDefault<z.ZodOptional<z.ZodNumber>>;
	},
	'strip',
	z.ZodTypeAny,
	{
		text: string;
		id: string;
		occurrence: number;
		locale: string;
	},
	{
		text: string;
		id: string;
		locale: string;
		occurrence?: number | undefined;
	}
> = z.object({
	/** Unique key identifying the current ghost text set */
	id: z.string(),
	/** Locale of the ghost text */
	locale: z.string(),
	/** The placeholder text to display */
	text: z.string(),
	/** Number of times this text has been shown (0-2, resets after 3) */
	occurrence: z.number().optional().default(0),
});
